import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class SwitcherIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="26" viewBox="0 0 24 26" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.136 18.067c.325.248.397.76.149 1.09-1.573 2.063-3.904 3.246-6.452 3.246H.773A.755.755 0 0 1 0 21.625c0-.446.329-.778.773-.778h2.06a6.42 6.42 0 0 0 5.196-2.595c.242-.397.741-.474 1.107-.185zm2.522-10.013a.698.698 0 0 1-.473-.193c-.355-.25-.391-.757-.14-1.091 1.553-2.001 3.874-3.14 6.381-3.14h3.943l-2.29-2.305a.77.77 0 0 1 0-1.095.757.757 0 0 1 1.088 0l3.605 3.63a.77.77 0 0 1 0 1.095l-3.605 3.63a.796.796 0 0 1-.544.231.796.796 0 0 1-.544-.23.77.77 0 0 1 0-1.095l2.29-2.305h-3.943c-2.021 0-3.892.933-5.137 2.54a.736.736 0 0 1-.631.328zm7.388 10.455a.77.77 0 0 1 0-1.095.757.757 0 0 1 1.087 0l3.605 3.63a.77.77 0 0 1 0 1.095l-3.605 3.63a.796.796 0 0 1-.543.231.796.796 0 0 1-.544-.23.77.77 0 0 1 0-1.095l2.29-2.305h-3.908c-4.292 0-7.831-3.41-8.051-7.729v-2.836c0-3.634-2.933-6.587-6.541-6.587H.776a.755.755 0 0 1-.773-.778c0-.447.329-.778.773-.778h2.06c4.291 0 7.83 3.409 8.05 7.728v2.837c0 3.633 2.934 6.587 6.542 6.587h3.907l-2.289-2.305z"/></svg>
        )
    }
}

export default withCssClassName(SwitcherIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/switcher-icon.js